module.exports = __webpack_public_path__ + "img/9788961705899.6b14f7a5.jpg";